var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMineName(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "18px",
    viewBox: "0 0 17 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_mine_name") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4E2A\\u4EBA\\u4E2D\\u5FC3-\\u6211\\u7684\\u4FE1\\u606F",
    transform: "translate(-477, -445)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_mine_name",
    transform: "translate(475, 443)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fillOpacity: 0,
    fill: "#D8D8D8",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0544166,2 C14.250314,2 14.4375062,2.07909881 14.5714999,2.21876932 L18.8080416,6.62876929 C18.931439,6.75721302 19,6.92680839 19,7.10300007 L19,16.5384616 C19,18.4502165 17.4143417,20 15.4583333,20 L5.54166666,20 C3.58565818,20 2,18.4502165 2,16.5384616 L2,5.46153853 C2,3.54978364 3.58565818,2 5.54166666,2 L14.0544166,2 Z M13.7484166,3.38461546 L5.54166666,3.38461546 C4.36806157,3.38461546 3.41666667,4.31448559 3.41666667,5.46153853 L3.41666667,16.5384616 C3.41666667,17.6855145 4.36806157,18.6153846 5.54166666,18.6153846 L15.4583333,18.6153846 C16.0219183,18.6153846 16.5624204,18.3965666 16.9609352,18.007068 C17.35945,17.6175693 17.5833332,17.0892958 17.5833332,16.5384616 L17.5833332,7.37715392 L13.7484166,3.38461546 Z M13.6874999,7.71153853 C14.0787016,7.71153853 14.3958333,8.02149524 14.3958333,8.40384621 C14.3958333,8.78619719 14.0787016,9.09615389 13.6874999,9.09615389 L11.2083333,9.09615389 L11.2083333,14.9807693 C11.2083333,15.3631202 10.8912016,15.6730769 10.5,15.6730769 C10.1087983,15.6730769 9.79166665,15.3631202 9.79166664,14.9807693 L9.79166664,9.09615389 L7.31249997,9.09615389 C6.92129828,9.09615389 6.60416665,8.78619719 6.60416665,8.40384621 C6.60416665,8.02149524 6.92129828,7.71153853 7.31249997,7.71153853 L13.6874999,7.71153853 L13.6874999,7.71153853 Z",
    id: "\\u5F62\\u72B6",
    fill: "#999999",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMineName);
export default __webpack_public_path__ + "static/media/icon_mine_name.svg";
export { ForwardRef as ReactComponent };